import React from 'react';

function Modal({ show, onClose, onConfirm, title, children, hideFooter = false, className = '' }) {
  if (!show) {
    return null; 
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      {/* YENİ: className prop'u eklendi. Böylece 'modal-content-wide' kullanabileceğiz */}
      <div className={`modal-content ${className}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button onClick={onClose} className="modal-close-btn">&times;</button>
        </div>
        
        {/* İçerik alanı kaydırılabilir olsun */}
        <div className="modal-body" style={{ overflowY: 'auto' }}>
          {children}
        </div>
        
        {!hideFooter && (
          <div className="modal-footer">
            <button onClick={onClose} className="admin-button-secondary">
              İptal
            </button>
            <button onClick={onConfirm} className="admin-button">
              Onayla
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Modal;